import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { apiGet, getAccountsApiUrl } from '../common/AppApi';

import TransactionSearch from './TransactionSearch';

export default function Transactions() {
  const history = useHistory(); // (you can remove if unused)
  const location = useLocation();

  let [programs, setPrograms] = useState([]);

  let getPrograms = () => {
    let url = getAccountsApiUrl() + '/account/programs';
    apiGet(url).then((resp)=> {
      let programs = [];
      programs.push({id:'',text:''});
      resp.forEach((p) => {
        programs.push({id:p.programUuid, text:p.programName});
      });
      setPrograms(programs);
    }).catch((err) => {
      console.error(err);
    });
  };

  useEffect(() => {
    getPrograms();
  }, []);

  // read query params
  const params = new URLSearchParams(location.search);
  const recipientAccountId = params.get('recipientAccountId') || params.get('rid') || '';
  console.log('recipient id' +recipientAccountId );
  const auto = params.get('auto') === '1';

  return (
    <>
      <TransactionSearch
        programs={programs}
        basePath="/program"
        initialRecipientAccountId={recipientAccountId}
        autoSearch={auto}
      />
    </>
  );
}